import {
    createAsyncThunk,
    createSlice,
    PayloadAction,
} from "@reduxjs/toolkit";
import * as transportPlanService from "../../../services/transportPlanService";
import {
    TransportPlanDetailsDto,
    TransportPlanListItemDto,
    TransportPlanListQueryParameters,
} from "../../../models/transport/transportPlan";
import dayjs, { Dayjs } from "dayjs";
import { fetchTransportPlan, transportPlanToCommonTransportModel } from "../../../services/transportPlanService";
import { TransportOrTransportPlan } from "../../../models/transport/transport";
import { TransportPlanState as TransportPlanStateEnum } from "../../../models/transport/transportPlan";

export interface TransportPlanState {
    transportPlan: TransportOrTransportPlan | null;
    transportPlans: TransportOrTransportPlan[];
    selectedDate: string;
    startDate: string;
    endDate: string;
}

const initialState: TransportPlanState = {
    transportPlan: null,
    transportPlans: [],
    selectedDate: dayjs().toISOString(),
    startDate: dayjs().startOf("week").add(1, "day").toISOString(),
    endDate: dayjs().endOf("week").toISOString()
};

export const transportPlanSlice = createSlice({
    name: "transportPlan",
    initialState,
    reducers: {
        setTransportPlans: (state, action: PayloadAction<TransportPlanListItemDto[]>) => {
            state.transportPlans = action.payload.map(transportPlanToCommonTransportModel);
        },
        setTransportPlan: (state, action: PayloadAction<TransportPlanDetailsDto>) => {
            state.transportPlan = transportPlanToCommonTransportModel(action.payload);
        },
        setSelectedDate: (state, action: PayloadAction<Dayjs>) => {
            const date = action.payload;
            state.selectedDate = date.toISOString();
            state.startDate = date.startOf("week").add(1, "day").toISOString();
            state.endDate = date.endOf("week").toISOString();
        },
        setPlanState: (state, action: PayloadAction<{ planId: string; state: TransportPlanStateEnum }>) => {
            const items = state.transportPlans.slice();
            items.find(tp => tp.transportPlanId === action.payload.planId).transportPlanState = action.payload.state;
            state.transportPlans = items;
        },
    },
});

export const {
    setSelectedDate,
    setPlanState,
    setTransportPlans,
    setTransportPlan,
} = transportPlanSlice.actions;

export const listTransportPlans = createAsyncThunk(
    "transportPlan/list",
    async(params: TransportPlanListQueryParameters, thunkApi) => {
        const res = await transportPlanService.getTransportPlans(
            params,
            thunkApi.signal
        );
        thunkApi.dispatch(setTransportPlans(res.data));
    }
);

export const fetchSingleTransportPlan = createAsyncThunk(
    "transportPlan/fetch",
    async(id: string, thunkApi) => {
        const plan = (await fetchTransportPlan(id)).data;
        thunkApi.dispatch(setTransportPlan(plan));
    }
);

export const transportPlanReducer = transportPlanSlice.reducer;
